// Common business categories for Indian listings
export const businessCategories = [
  // Repairs & Services
  "Repairs & Services",
  "Electrician", "Carpenter", "Plumber", "AC Service", "CCTV & Home Services",
  // Real Estate
  "Real Estate",
  "Property agents", "Brokers", "PG/Hostels", "Estate Agents",
  // Doctors & Health Services
  "Doctors & Health Services",
  "Hospitals", "Clinics", "Dentists", "Gynecologists", "Health Practitioners",
  // Beauty & Wellness
  "Beauty & Wellness",
  "Beauty Spa", "Salons", "Massage", "Yoga Studios",
  // Home Decor & Renovation
  "Home Decor & Renovation",
  "Interior Decorators", "Contractors", "Painters", "Home Furnishing",
  // Event & Wedding Services
  "Event & Wedding Services",
  "Event Organisers", "Wedding Planners", "Photographers",
  // Education & Training
  "Education & Training",
  "Institutes", "Tutors", "Coaching Classes", "Training Centers",
  // Rent & Hire Services
  "Rent & Hire Services",
  "Car/Bike Hire", "Driver on Call", "Equipment Rentals",
  // Fitness & Lifestyle
  "Fitness & Lifestyle",
  "Gyms", "Trainers", "Sports Coaches", "Wellness Programs",
  // Loans & Finance
  "Loans & Finance",
  "Loan Consultants", "Financial Services", "Property Loans",
  // Food & Hospitality
  "Food & Hospitality",
  "Restaurants", "Hotels", "Bakery", "Cafes", "Supermarket",
  // Other
  "Retail", "Courier Service", "Pet Shops", "Driving Schools", "Automotive", "Entertainment", "IT Services", "Consultancy", "Travel Agency", "Pharmacy", "Electronics", "Jewellery", "Clothing", "Furniture", "Bookstore", "Florist", "Spa", "Repair Services", "Legal Services", "Accounting", "Marketing", "Logistics", "Manufacturing", "Healthcare", "Fitness", "Childcare", "Cleaning Services", "Security Services"
];
